import GeoJSON from "ol/format/GeoJSON";
import { toLonLat } from "ol/proj";

import { STATIONS_SOURCE_LAYER_SCHEMATIC } from "../constants";

let layers;

const format = new GeoJSON({
  featureProjection: "EPSG:3857",
});

/**
 * Returns the first feature from tthe mapbox layer related to a station.
 */
const getStationFromSchematicLayer = async (pixel, schematicLayer) => {
  const style = schematicLayer?.mbMap?.getStyle();
  if (!style?.layers) {
    return null;
  }

  if (!layers) {
    layers = [
      ...style.layers
        .filter((layer) => {
          return STATIONS_SOURCE_LAYER_SCHEMATIC.includes(
            layer["source-layer"],
          );
        })
        .map((layer) => layer.id),
    ];
  }
  window.mbMap = schematicLayer?.mbMap;
  const [vtFirstFeature] = schematicLayer.mbMap.queryRenderedFeatures(pixel, {
    layers,
  });

  if (!vtFirstFeature) {
    return null;
  }

  const first = format.readFeature(vtFirstFeature);
  return first;
};

export default getStationFromSchematicLayer;
